// /src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

import HomeView from '../views/HomeView.vue'
import AlertasView from '../views/AlertasView.vue'
import AnalisisView from '../views/AnalisisView.vue'
import HeatmapsView from '../views/HeatmapsView.vue'
import HeatmapView from '../views/HeatmapView.vue'
import AdminView from '../views/AdminView.vue'
import ProductoView from '../views/ProductoView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/alertas',
    name: 'alertas',
    component: AlertasView
  },
  {
    path: '/analisis',
    name: 'analisis',
    component: AnalisisView
  },
  {
    path: '/heatmaps',
    name: 'heatmaps',
    component: HeatmapsView
  },
  {
    path: '/heatmap/:id',
    name: 'heatmap-view',
    component: HeatmapView
  },
  {
    path: '/admin/usuarios',
    name: 'admin-usuarios',
    component: AdminView
  },
  {
    path: '/producto/:codigo',
    name: 'producto',
    component: ProductoView,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router